import React, { useEffect, useState } from "react";
import { Container, Form } from "react-bootstrap";
import clsx from "clsx";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../selectors/auth";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import { useHistory } from "react-router";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import _ from "lodash";
import { useParams } from "react-router-dom";
import * as ipoSelectors from "../../selectors/ipo";
import * as NumericInput from "react-numeric-input";
import { Controller, useForm } from "react-hook-form";
import NotificationMessage from "../../utils/NotificationMessage";
import CustomEmptyFont from "../../components/CustomEmptyFont";
import CustomPriceSpan from "../../components/CustomPriceSpan";
import LoadingOverlay from "../../components/LoadingOverlay";
import * as ipoActions from "../../action/ipo";

function EIPOSubscribe({ ipoConfig }) {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const dispatch = useDispatch();
  const { ipoID } = useParams();
  const defaultNumberOfShares = useSelector((state) =>
    _.get(state, ["ipo", "data", "number_of_share_applied"]),
  );
  const raceData = useSelector((state) =>
    _.get(state, ["ipo", "data", "race"], null),
  );
  const races = ipoSelectors.getIpoConfigRaces(ipoConfig);
  const trustBalance =
    ipoSelectors.getIpoConfigMetadataTotalTrustBalance(ipoConfig);
  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const history = useHistory();
  const { data, isLoading } = useQuery({
    queryKey: ["subscribe-ipo", { ipoID }],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo/${ipoID}`);
      } catch (e) {
        const error = _.get(e, ["status"]);
        if (error == "404") {
          setNotFound(true);
        }
        Helper.handleHttpError(e, dispatch, history);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token) && !_.isEmpty(ipoID),
  });

  const {
    register,
    handleSubmit,
    getValues,
    watch,
    formState: { errors },
    setValue,
    control,
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    // reValidateMode: "onChange",
    defaultValues: {
      number_of_share_applied: defaultNumberOfShares,
      race: raceData,
    },
  });

  useEffect(() => {
    setValue("race", raceData);
  }, [raceData, races]);
  const onSubmit = async (values) => {
    setLoading(true);
    const numberOfShare = values.number_of_share_applied;
    const ts = Math.floor(new Date() / 1000).toString();
    try {
      const response = await axiosInstance.get(
        `/clientarea/ipo/contract?ts=${ts}&ipo_id=${ipoID}&number_of_share_applied=${numberOfShare}`,
        {},
        false,
      );
      const metaData = _.get(response, "metadata", null);
      const is_insufficient_balance = _.get(
        metaData,
        "is_insufficient_balance",
        false,
      );
      const total_trust_balance = _.get(metaData, "total_trust_balance", 0);
      if (is_insufficient_balance) {
        NotificationMessage.error("Insufficient Balance.");
      } else {
        dispatch(ipoActions.setIPOData({ ...values, ipoID: ipoID }));

        history.push(`/dashboard/e-ipo/subscribe/${ipoID}/confirmation`);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
    // const numberofShare = values.number_of_share_applied;
    //
    // if (numberofShare > 0) {
    //   dispatch(ipoActions.setIPOData(values));
    //   history.push(
    //     `/dashboard/e-ipo/subscribe/${ipoID}/confirmation?ts=${Math.floor(new Date() / 1000).toString()}`,
    //   );
    // } else {
    //   NotificationMessage.error("Please fill in how many share to apply.");
    // }
  };

  const onHandleBack = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const onChangeType = (e) => {};
  const numberOfShares = watch("number_of_share_applied");
  const ipoData = _.get(data, ["data"], null);
  const companyLogo = ipoSelectors.getIPODetailCompanyLogoFull(ipoData);
  const stockCode = ipoSelectors.getIPODetailStockCode(ipoData);
  const stockName = ipoSelectors.getIPODetailStockName(ipoData);
  const pricePerShare = ipoSelectors.getIPODetailPricePerShare(ipoData);
  const pricePerShareValue =
    ipoSelectors.getIPODetailPricePerShareValue(ipoData);
  const lotSize = ipoSelectors.getIPODetailLotSizeValue(ipoData);
  const currencySymbol = ipoSelectors.getCurrencyCodeSymbol(ipoData);
  return (
    <Container fluid>
      <Form onSubmit={handleSubmit(onSubmit, (e) => {})}>
        <div className="ipo-detail-container">
          <div className="ipo-top-right-component">
            <div className="ipo-title">{stockName}</div>
            <div className="ipo-stockcode">{stockCode}</div>
          </div>
          <div
            className={"primary-border-table-border mt-4"}
            style={{ backgroundColor: "white" }}
          >
            <div
              className={clsx(
                "d-flex custom-card-label-container align-items-center justify-content-center",
              )}
            >
              <h2>Subscribe</h2>
            </div>
            <div
              className={clsx("custom-table-info-container padding-12px mt-3 mb-1")}
            >
              <div className="ipo-subscribe-container">
                <div className="ipo-subscribe-detail-container">
                  <div className="ipo-subscribe-content" style={{ flex: 1 }}>
                    <div className="ipo-subscribe-content-title">
                      Share Price
                    </div>
                    <div className="ipo-subscribe-content-text">
                      <CustomEmptyFont
                        variant="span"
                        value={pricePerShare}
                      ></CustomEmptyFont>
                    </div>
                  </div>
                  <div className="ipo-subscribe-content" style={{ flex: 2 }}>
                    <div className="ipo-subscribe-content-title">Race</div>
                    <div className="ipo-subscribe-content-text">
                      <Form.Select
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          borderRadius: "4px",
                        }}
                        isInvalid={errors?.race}
                        disabled={loading}
                        // defaultValue={raceData}
                        className="formControl"
                        {...register(`race`, {
                          required: "Please select race",
                        })}
                      >
                        <option value="">Please Select Race</option>
                        {!_.isEmpty(races)
                          ? _.map(races, (item, index) => {
                              const value = _.get(item, ["value"], "");
                              const text = _.get(item, ["text"], "");
                              return (
                                <option key={index} value={value}>
                                  {text}
                                </option>
                              );
                            })
                          : false}
                      </Form.Select>
                    </div>
                  </div>
                  <div className="ipo-subscribe-content" style={{ flex: 2 }}>
                    <div className="ipo-subscribe-content-title">
                      Subscription Method
                    </div>
                    <div className="ipo-subscribe-content-text">
                      <Form.Select
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          borderRadius: "4px",
                        }}
                        disabled
                        // isInvalid={errors?.race && true}
                        className="formControl"
                        {...register(`method`)}
                      >
                        <option value="">Trust Money</option>
                      </Form.Select>
                    </div>
                  </div>
                  <div className="ipo-subscribe-content" style={{ flex: 2 }}>
                    <div className="ipo-subscribe-content-title">
                      <span>No of shares to subscribe (x{lotSize})</span>
                    </div>
                    <div className="ipo-subscribe-content-text">
                      <Controller
                        name={`number_of_share_applied`}
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, onBlur, value } }) => (
                          <NumericInput
                            min={0}
                            mobile
                            className="form-control"
                            onChange={onChange}
                            value={value}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="ipo-subscribe-detail-container justify-content-end">
                  <div className="d-flex total-price-container total-price-container-mobile">
                    <div className="ipo-subscribe-total-container justify-content-end">
                      <div className="w-100">Total Trust Amount</div>
                      <div className="ipo-price-value">
                        <CustomPriceSpan value={trustBalance}></CustomPriceSpan>
                      </div>
                    </div>
                    <div className="ipo-subscribe-total-container justify-content-end mt-2">
                      <div className="w-100">Total Subscription Amount</div>
                      <div className="ipo-price-value">
                        {Helper.formattedPrice(
                            numberOfShares * pricePerShareValue * lotSize,
                        )}
                      </div>
                    </div>
                    <div className="divider-ipo mt-2"></div>
                    <div className="ipo-subscribe-total-container justify-content-end mt-2">
                      <div className="w-100">Balance Amount</div>
                      <div className="ipo-price-value">
                        <CustomPriceSpan
                            value={
                                (numberOfShares * pricePerShareValue * lotSize) + trustBalance
                            }
                        />
                      </div>
                    </div>
                    {
                      numberOfShares > 0 ? (
                          <div className="ipo-subscribe-total-container justify-content-end mt-2">
                            {
                              trustBalance + (numberOfShares * pricePerShareValue * lotSize) > 0 ?
                                  (<span className="text-danger">Insufficient Balance</span>) :
                                  (<span className="text-success">The enter amount is valid</span>)

                            }
                          </div>
                      ) : (<></>)
                    }
                  </div>
                </div>
              </div>
            </div>
            <hr></hr>
            {/*<div className="p-4 pt-0">*/}
            {/*  <div>Important Notes</div>*/}
            {/*  <ol className="px-3 mb-0">*/}
            {/*    <li>*/}
            {/*      By proceeding with the eIPO application, hereby I confirm I had read and understood the*/}
            {/*      Terms of Service Provided Ta Bursa e-IPO Application Terms of Services.*/}
            {/*    </li>*/}
            {/*    <li>*/}
            {/*      Investors were advised to conduct your own investment analysis and risk assessment before*/}
            {/*      applying to eIPO, Malacca Securities Sdn Bhd are not responsible for any investment losses*/}
            {/*      arising from any investment transaction including but not limited to eIPO application.*/}
            {/*    </li>*/}
            {/*    <li>*/}
            {/*      eIPO application can be modified by cancelling your current application and resubmit it*/}
            {/*      before the stipulated deadline. Please note that processing time is required for*/}
            {/*      cancellation and refunds, you are advised to do this at least once day before the deadline.*/}
            {/*    </li>*/}
            {/*    <li>*/}
            {/*      After submitting your application, kindly check your registered email for the confirmation*/}
            {/*      email to ensure all details submitted are accurate and up to date.*/}
            {/*    </li>*/}
            {/*    <li>*/}
            {/*      Please be aware that there is a risk of the IPO listing being cancelled or postponed, In*/}
            {/*      such cases, please note that the eIPO handling charges are not refundable.*/}
            {/*    </li>*/}
            {/*    <li>*/}
            {/*      If you are using an Islamic Trading Account, kindly verify the Shariah status of the IPO*/}
            {/*      counter before applying. If the securities are found to be Shariah non-compliant, the*/}
            {/*      Shariah Advisory Council (SAC) advises to dispose of them and donate any return/profits to*/}
            {/*      charity and only retain the investment cost.*/}
            {/*    </li>*/}
            {/*  </ol>*/}
            {/*  <div className="mt-2">*/}
            {/*    Should you need further assistance, please email our customer service at support@ta.com.my*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className="d-flex justify-content-center py-3">
              <button
                className={clsx("btn custom-button-back")}
                //  type="submit"
                onClick={onHandleBack}
              >
                Back
              </button>
              <button
                className={clsx("btn custom-button-primary")}
                type="submit"
                // disabled={numberOfShares==0 || loading}
                disabled={
                  isNaN(numberOfShares) ||
                  numberOfShares == null ||
                  numberOfShares == 0 ||
                  trustBalance + (numberOfShares * pricePerShareValue * lotSize) >
                    0 ||
                  loading
                }
                style={{ backgroundColor: "#9D7905" }}
                // onClick={handleSubmit(onSubmit)}
              >
                Next
                <LoadingOverlay
                  loading={loading}
                  isSemiLoading={true}
                ></LoadingOverlay>
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Container>
  );
}

export default EIPOSubscribe;
